<template>
  <form class="p-2" @submit.prevent="handleAddContact">
    <modal-container :show="show" @close="onCancel">
      <template slot="header">
        <h4 class="mb-0 text-capitalize"> {{  $t("add_contact") }}</h4>
      </template>

      <template slot="body">
        <div class="align-items-center d-flex col-gap-1">
          <div class="form-group w-100">
            <label for="name"> {{ $t ("reciever_name")}} </label>
            <input
              type="text"
              v-model="name"
              class="form-control"
              required
              id="name"
            />
          </div>

          <div class="form-group w-100">
            <label for="email"> {{ $t("email") }}</label>
            <input
              type="email"
              v-model="email"
              class="form-control"
              required
              id="email"
            />
          </div>
        </div>
        <div class="d-flex col-gap-1">
          <div class="form-group w-100">
            <label for="phone"> {{ $t("phone_num") }}</label>
            <input
              type="tel"
              v-model="phoneNumber"
              class="form-control"
              required
              id="phone"
            />
          </div>
          <div class="form-group w-100">
            <label for="item">{{ $t("assign-item") }}</label>
            <Dropdown
              :items="dropdownData"
              @update:selectedItems="handleSelectedItems"
              :itemsSelected="selectedItems"
            />
            <p v-if="showError" class="text-error font-12 mb-0">
              {{ $t("select_one") }}
            </p>
          </div>
        </div>

        <div class="form-group w-100">
          <label for="address"> {{ $t("address") }} </label>
          <input
            type="text"
            v-model="address"
            class="form-control"
            required
            id="address"
          />
        </div>
      </template>
      <template slot="footer">
        <div style="display: flex; justify-content: end">
          <button type="submit" class="btn btn-primary text-capitalize">
            {{ $t("add") }}
          </button>
        </div>
      </template>
    </modal-container>
  </form>
</template>

<script>
import ModalContainer from "../../../components/ModalContainer.vue";
import Dropdown from "./Dropdown.vue";

export default {
  name: "AddContactModal",
  components: {
    ModalContainer,
    Dropdown,
  },
  computed: {
    availableItems() {
      return [...this.selectedItems, ...this.items];
    },
  },
  props: {
    show: Boolean,
    onCancel: Function,
    items: Array,
    initialValues: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      name: this.initialValues?.contact?.name || "",
      email: this.initialValues?.contact?.email || "",
      phoneNumber: this.initialValues?.contact?.phoneNumber || "",
      address: this.initialValues?.contact?.address || "",
      selectedItems: this.initialValues?.items || [],
      showError: false,
      dropdownData: [],
    };
  },
  mounted() {
    this.dropdownData = [...this.selectedItems, ...this.items];
  },
  methods: {
    handleAddContact() {
      if (!this.selectedItems.length) {
        this.showError = true;
        return;
      }
      const contact = {
        name: this.name,
        email: this.email,
        phoneNumber: this.phoneNumber,
        address: this.address,
      };

      const payload = {
        contact,
        items: this.selectedItems,
      };
      this.$emit("addContact", payload);
    },
    handleSelectedItems(selectedItems) {
      this.selectedItems = selectedItems;
    },
  },
  watch: {
    initialValues: {
      handler(newValues) {
        if (newValues.contact) {
          this.name = newValues.contact.name || "";
          this.email = newValues.contact.email || "";
          this.phoneNumber = newValues.contact.phoneNumber || "";
          this.address = newValues.contact.address || "";
          this.selectedItems = newValues.items || [];
        }
      },
      deep: true,
    },
  },
};
</script>

<style></style>
